import { render, staticRenderFns } from "./ProductCardHorizontal.vue?vue&type=template&id=dbb36872"
import script from "./ProductCardHorizontal.vue?vue&type=script&lang=js"
export * from "./ProductCardHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports